import React, { PropsWithoutRef } from 'react';

import type { User } from 'ts_shared';

import AutocompleteSingleOption from 'components/AutocompleteSingleOption';
import type { ResourceFormProps } from 'types';
import {
  ResellersRolesListApiResponse,
  useCompaniesRolesListQuery,
  useResellersRolesListQuery,
  useUsersGroupsListQuery,
} from 'services/api/general';
import ControllerWithError from 'libs/react-hook-form/ControllerWithError';
import { UserFormUserType } from '../../types';

interface IProps extends PropsWithoutRef<ResourceFormProps<User>> {
  userType: UserFormUserType;
}

const UserGroupDropdownForm = ({ control, userType }: IProps) => {
  let roles: ResellersRolesListApiResponse | undefined;

  if (userType === 'internal') {
    const { data } = useResellersRolesListQuery();
    roles = data;
  } else if (userType === 'end_user') {
    const { data } = useCompaniesRolesListQuery();
    roles = data;
  } else if (userType === 'external') {
    const { data } = useUsersGroupsListQuery({ user_buckets: ['external'] });
    roles = data;
  }

  const roleOptions =
    roles?.map((role) => ({ label: role.name, value: role.id })) || [];

  return (
    <ControllerWithError
      control={control}
      name="group"
      render={({ field: { value, onChange } }) => (
        <AutocompleteSingleOption
          label=""
          options={roleOptions}
          onChange={(_, newValue) => {
            if (newValue) onChange(newValue.value);
          }}
          id="user-groups-dropdown"
          value={roleOptions?.find((role) => role.value === value) || null}
          textFieldProps={{
            variant: 'standard',
          }}
        />
      )}
    />
  );
};

export default UserGroupDropdownForm;
